// Logo & brand constants
export const LOGO_URL = "https://customer-assets-lxgj4vgw.emergentagent.net/job_manicure-studio-hub/artifacts/i1k7fi46_perfil.png";
export const BRAND = {
  name: "Arya Studio",
  tagline: "Onde cuidado e beleza se encontram.",
  instagram: "@Arya Studio",
  whatsapp: "5521992483417",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1658492055212-e1acbccfca5a?crop=entropy&cs=srgb&fm=jpg&q=85",
  interior: "https://images.unsplash.com/photo-1652869122685-c7792ef56ee2?crop=entropy&cs=srgb&fm=jpg&q=85",
  crafting: "https://images.unsplash.com/photo-1690749138086-7422f71dc159?crop=entropy&cs=srgb&fm=jpg&q=85",
  glitter: "https://images.pexels.com/photos/28712961/pexels-photo-28712961.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  nude: "https://images.pexels.com/photos/35491156/pexels-photo-35491156.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  consult: "https://images.unsplash.com/photo-1693776528429-f73dd0586329?crop=entropy&cs=srgb&fm=jpg&q=85",
};
